import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'

import formId from 'constants/formIds/themeSaver'

import Modal from 'components/Modal'
import ModalContent from 'components/ModalContent'

import ThemeSaver from 'components/forms/ThemeSaver'

import {
  getVisible,
  getField,
  getMode,
  getOnCancel,
  getOnSave,
  getOnClickCloseButton,
  getInitialValues,
  getLoading,
} from 'selectors/elements/modals/themeSaver'

const mapStateToProps = (state) => state

const mapDispatchToProps = (dispatch) => ({ dispatch })

const mergeProps = (state, { dispatch }, ownProps) => ({
  ...ownProps,
  show: getVisible(state),
  initialValues: getInitialValues(state),
  children: (
    <ModalContent
      onClickCloseButton={ getOnClickCloseButton(state) }
    >
      <ThemeSaver
        field={ getField(state) }
        loading={ getLoading(state) }
        mode={ getMode(state) }
        onCancel={ getOnCancel(state) }
        onSave={ getOnSave(state) }
      />
    </ModalContent>
  ),
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
  ),
  reduxForm({
    form: formId.name,
    destroyOnUnmount: true,
    enableReinitialize: true,
    onSubmit: () => null,
  })
)(Modal)
